<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item label="话题ID">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="栏目">
                        <el-select v-model="lb_value" placeholder="请选择" size="small" filterable>
                            <el-option v-for="item in  lb_options" :key="item.id" :label="item.classname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="时间">
                        <el-date-picker v-model="times" size="small" type="daterange" value-format="yyyy-MM-dd"
                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-printer" size="small" plain @click="openExportExcel">
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="topic_id" label="话题ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="id" label="发帖ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="user_id" label="用户ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="图片">
                    <template slot-scope="scope">
                        <div class="u-f u-wrap">
                            <div v-if="scope.row.titlepic">
                                <!-- <img :src="scope.row.titlepic" alt="" width="50" class="tablimg"> -->
                                <el-image style="width:70px; height: 70px" :src="scope.row.titlepic" fit='cover' :preview-src-list="[scope.row.titlepic]">
                                </el-image>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="ht" label="话题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="user.username" label="用户昵称" width="150">
                    <template slot-scope="{row}">
                        <span v-if="row.is_fictitious==1">{{row.user?row.user.username:'游客'}}</span>
                        <span v-else-if="row.is_fictitious==2">{{row.users.username}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="view_count" label="浏览量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="comment_count" label="回复量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==0">待审核</span>
                        <span v-else-if="scope.row.status==1" style="color:green">审核通过</span>
                        <span v-else-if="scope.row.status==2" style="color:red">审核未通过</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="380" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" v-if="scope.row.is_top!=1" @click="handle_top(scope.row,1)">
                            置顶</el-button>
                        <el-button size="mini" type="text" v-else @click="handle_top(scope.row,0)">取消置顶
                        </el-button>
                        <el-button size="mini" type="text" @click="handleexam(scope.$index, scope.row)">审核
                        </el-button>
                        <el-button size="mini" type="text" @click="handleEdit(scope.row,scope.$index)">编辑</el-button>
                        <el-button size="mini" type="text" @click="detailbtn(scope.row,scope.$index)">详情</el-button>
                        <el-button size="mini" type="text" @click="dsbtn(scope.row,scope.$index)">打赏积分</el-button>
                        <el-button size="mini" type="text" v-if="scope.row.is_essence==0" @click="jhbtn(scope.row,1)">精华
                        </el-button>
                        <el-button size="mini" type="text" v-else @click="jhbtn(scope.row,0)">取消精华</el-button>
                        <el-button size="mini" type="text" @click="ydbtn(scope.row,scope.$index)">移动</el-button>
                        <el-button size="mini" type="text" @click="handleDelete(scope.row,scope.$index)"
                            style="color:#8d8d8d">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="录入" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="人员" prop='ry_value'>
                        <el-select v-model="ruleForm.ry_value" placeholder="请选择" size="small" filterable
                            @change="selectUser">
                            <el-option v-for="item in  ry_options" :key="item.id"
                                :label="item.username+'--'+item.sex_text" :value="item.id">
                            </el-option>
                        </el-select>

                    </el-form-item>
                    <el-form-item label="类别" prop='lb_value'>
                        <el-select v-model="ruleForm.lb_value" placeholder="请选择" size="small" filterable>
                            <el-option v-for="item in  lb_options" :key="item.id" :label="item.classname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="可见" prop='kj_value'>
                        <el-select v-model="ruleForm.kj_value" placeholder="请选择" size="small" filterable>
                            <el-option v-for="item in  kj_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="图片" required>
                        <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                            :headers="{ 'token':$store.state.user.token }"
                            :data="{ image_class_id:'72',file_type:'1',userId:this.ruleForm.ry_value }"
                            :file-list="ruleForm.lb_mapList" :before-upload="beforeUpload" :on-success="uploadSuccess"
                            :limit="1" :on-remove="uploadRmove" list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>

                    <el-form-item label="关键词" prop='keyword'>
                        <el-input v-model="ruleForm.keyword" placeholder="请输入关键词" size="small" class="zwidth">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="内容" prop="textarea">
                        <tinymce ref="editor" v-model="ruleForm.textarea" @onClick="onClick"
                            toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
                    </el-form-item>
                    <!-- <el-form-item label="话题" required>
                        <div class="u-f">
                            <el-form-item prop='ht_value'>
                                <el-select v-model="ruleForm.ht_value" placeholder="请选择" size="small" filterable
                                    @change="selecthttit">
                                    <el-option v-for="item in  ht_options" :key="item.id" :label="item.classname"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop='ht_value2'>
                                <el-select v-model="ruleForm.ht_value2" placeholder="请选择" size="small" filterable>
                                    <el-option v-for="item in  ht_options2" :key="item.id" :label="item.title"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form-item> -->
                    <el-form-item label="发布设置" prop='lb_put'>
                        <el-radio-group v-model="ruleForm.lb_put">
                            <el-radio :label="1" style="width:100%;margin-bottom:0px">立即发布</el-radio>
                            <div>
                                <el-radio :label="2">定时发布</el-radio>
                                <el-date-picker v-model="ruleForm.lb_dstime" :clearable="false"
                                    :disabled="ruleForm.lb_put==2?false:true" size="mini" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间" default-time="12:00:00">
                                </el-date-picker>
                            </div>
                            <el-radio :label="3" style="width:100%">暂不发布</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="detaildialogVisible" center top="20px" width="70%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="getruleForm" :rules="plrule" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="用户:">
                                <p class="yhname">{{getruleForm.rytext}}</p>
                            </el-form-item>

                            <el-form-item label="话题:">
                                <p>{{getruleForm.ht_value2}}</p>
                            </el-form-item>
                            <el-form-item label="内容:">
                                <p class="con_de" v-html="getruleForm.textarea"></p>
                            </el-form-item>
                            <el-form-item label="图片:">
                                <div v-if="getruleForm.images">
                                    <div class="imgbox">
                                        <div class="singleimg" v-for="(img,i) in getruleForm.images" :key="i">
                                            <el-image style="width: 50px; height: 50px" :src="img.url" fit='cover'
                                                :preview-src-list="[img.url]">
                                            </el-image>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    无图片
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span='12'>
                            <el-form-item label="人员" prop='ry_value2'>
                                <el-select v-model="getruleForm.ry_value2" placeholder="请选择" size="small" filterable
                                    @change="selectry">
                                    <el-option v-for="item in  ry_options" :key="item.id"
                                        :label="item.username+'--'+item.sex_text" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="赞一下">
                                <div class="zanbtn" @click="dzan">
                                    <img v-if="!zan" src="../../../assets/imgs/zan.png" alt="">
                                    <img v-else src="../../../assets/imgs/zan2.png" alt="">
                                </div>
                            </el-form-item>
                            <el-form-item label="评论" prop='pltext'>
                                <el-input type="text" placeholder="评论一下" v-model="getruleForm.pltext">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="评论:">
                                <div class="lefts" v-if="listItem&&listItem.length>0">
                                    <el-timeline :reverse="true">
                                        <el-timeline-item v-for="(item,index) in listItem" :key="index"
                                            :timestamp="item.create_time" placement="top">
                                            <div class="concon">
                                                <div class="u-f u-ac u-jsb">
                                                    <div class="u-f u-ac u-jsb" style="width:100%">
                                                        <div class="u-f u-ac">
                                                            <img :src="item.is_fictitious==1?item.user.userpic:item.users.userpic"
                                                                alt="" class="imgs">
                                                            <div>
                                                                {{item.is_fictitious==1?item.user.username:item.users.username}}
                                                                <span style="color:#8f8f8f">id:{{item.user_id}}</span>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <i class="el-icon-delete reds"
                                                                @click="handleDelet(item)"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="">{{item.content}}</div>
                                            </div>
                                        </el-timeline-item>
                                    </el-timeline>
                                </div>
                                <div v-else>
                                    暂无评论
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="plsubmit" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="detaildialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 审核 -->
        <el-dialog title="审核" :visible.sync="examdialogs" top="40px" width="70%" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="examForm" :rules="rule" ref="examForm" label-width="150px" v-loading='examloading'
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="标题：">
                        <span>{{examForm.name}}</span>
                    </el-form-item>
                    <el-form-item label="内容：">
                        <div class="con_b">
                            <span v-html="examForm.content"></span>
                        </div>
                    </el-form-item>
                    <el-form-item label="审核：">
                        <el-radio-group v-model="examForm.examradio">
                            <el-radio :label="1">审核通过</el-radio>
                            <el-radio :label="2">审核不通过</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="examForm.examradio==2" label="拒绝理由：">
                        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="examForm.remark">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="examsubmit()" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="examdialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!--  -->
        <el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
            <div style="margin: -60px -20px -30px -20px;">
                <img :src="urls" class="w-100" />
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialog_dsjf" width="30%" top="5vh" title="打赏积分">
            <el-form :model="dsForm" ref="dsForm" label-width="80px" class="demo-ruleForm forms-lines">
                <el-form-item label="积分：">
                    <el-input placeholder="请输入积分" type="number" v-model="dsForm.count" min="0">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dssubmit()" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialog_dsjf = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialog_move" width="30%" top="5vh" title="移动圈子">
            <div :style="{height:moveheight}" style="overflow:auto">
                <el-form :model="moveForm" ref="moveForm" label-width="80px" class="demo-ruleForm forms-lines">
                    <el-form-item>
                        <el-radio-group v-model="moveForm.move" size="medium">
                            <el-radio :label="s.id" style="display:block;margin-bottom:10px"
                                v-for="(s,index) in moveSquares" :key="index">{{s.title}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="movesubmit()" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialog_move = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 导出 -->
        <el-dialog title="导出数据" :visible.sync="exportModal" center width="30%">
            <el-form :model="exportForm" ref="ruleForm" label-width="80px">
                <el-form-item label="时间范围" required>
                    <el-date-picker size="small" v-model="exportForm.time" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <!-- <el-form-item label="状态">
                    <el-select v-model="exportForm.lb_value" placeholder="请选择" clearable size="small" filterable>
                        <el-option v-for="item in  lb_options" :key="item.id" :label="item.text" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportModal = false">取 消</el-button>
                <el-button type="primary" :loading='exporloading' @click="exportExcel">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    export default {
        components: {
            tinymce,
        },
        data() {
            return {
                lb_value: '',
                titles: '',
                times: [],
                lb_options: [],
                kj_options: [{
                    name: '所有人可见',
                    id: 1
                }, {
                    name: '仅自己可见',
                    id: 0
                }, ],
                ht_options: [],
                ht_options2: [],
                ry_options: [],
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 10,
                height: null,
                moveheight: null,
                // 
                eid: '0',
                dialogVisible: false,
                detaildialogVisible: false,
                subloading: false,
                dataId: '',
                listItem: [],

                ruleForm: {
                    lb_value: '',
                    keyword: '',
                    lb_dstime: '',
                    lb_put: 1,
                    lb_mapList: [],
                    kj_value: '',

                    ht_value: '',
                    ht_value2: '',
                    ry_value: '',
                    textarea: '',
                },
                getruleForm: {
                    rytext: '',
                    pltext: '',
                    ht_value2: '',
                    textarea: '',
                    kj_value: '',
                    lb_value: '',
                    images: '',
                    ry_value2: '',


                },
                zan: false,
                mapListed: [],
                rule: {
                    lb_value: [{
                        required: true,
                        message: '请选择类别',
                        trigger: 'blur'
                    }],
                    kj_value: [{
                        required: true,
                        message: '请选择谁可见',
                        trigger: 'blur'
                    }],

                    textarea: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],
                    ry_value: [{
                        required: true,
                        message: '请选择人员',
                        trigger: 'blur'
                    }],

                    ht_value: [{
                        required: true,
                        message: '请选择话题类型',
                        trigger: 'blur'
                    }],
                    ht_value2: [{
                        required: true,
                        message: '请选择话题列表',
                        trigger: 'blur'
                    }],
                    keyword: [{
                        required: true,
                        message: '请填写关键词',
                        trigger: 'blur'
                    }],
                    lb_put: [{
                        required: true,
                        message: '请选择发布设置',
                        trigger: 'blur'
                    }],
                },
                plrule: {
                    ry_value2: [{
                        required: true,
                        message: '请选择人员',
                        trigger: 'blur'
                    }],
                },
                // 
                examForm: {
                    remark: '',
                    examradio: '',
                    content: '',
                    name: '',
                    department: [],
                    user_value: '',
                    commission: 0
                },
                examloading: false,
                examdialogs: false,
                dialog_prev: false,
                urls: '',
                topic_child_options: [],
                selectUserdata: '',
                topic_id: '',
                dialog_dsjf: false,
                dsForm: {
                    count: 0
                },
                moveForm: {
                    move: '',
                },
                dialog_move: false,
                exportForm: {
                    time: [],
                    lb_value: ''
                },
                exportModal: false,
                exporloading: false,
                moveSquares: [],
                user_id: ''

            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        created() {
            if (sessionStorage.getItem('xuniUsers')) {
                this.ry_options = JSON.parse(sessionStorage.getItem('xuniUsers'))
            } else {
                this.getxnUser()
            }
        },
        mounted() {
            let that = this
            this.getsquares()
            that.getHeight()
            that.getlbxx()
            this.gethtlist()

        },
        methods: {
            getsquares() {
                axios.get(
                        `admin/topicclass/7/topic/1?limit=1000&manager_id=${this.user.username=='admin'?'':this.user.id}&role_id=${this.user.role_id}`, {
                            token: true
                        })
                    .then(res => {
                        this.moveSquares = res.data.data.list[1]
                    })
                    .catch(error => {})
            },
            getxnUser() {
                this.axios
                    .post(
                        "/admin/h5/fictitiousUsers", {
                            page: 1,
                            page_count: 3000
                        }, {
                            token: true
                        }
                    )
                    .then((res) => {
                        this.ry_options = res.data.data.list
                        sessionStorage.setItem('xuniUsers', JSON.stringify(res.data.data.list))
                    })
                    .catch((err) => {

                    });
            },
            selectUser(val) {
                this.ry_options.forEach(e => {
                    if (e.id == val) {
                        this.selectUserdata = e
                    }
                })
            },
            openExportExcel() {
                this.exportForm.time = []
                this.exportModal = true
            },
            exportExcel() {
                if (this.exportForm.time.length == 0) return this.$message.error('请选择时间范围')
                let val = this.exportForm.time
                let params = ''
                if (val && Array.isArray(val)) {
                    params += `&start=${val[0]}`
                    params += `&end=${val[1]}`
                }
                let url = `/admin/pc/excelPostExport?type=send&data_id=${this.titles}`

                this.exporloading = true
                this.axios.post(url + params, {}, {
                    token: true,
                    responseType: 'blob'
                }).then(res => {
                    if (res.status == 200) {
                        this.exportModal = false
                        let url = window.URL.createObjectURL(new Blob([res.data]))
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        let filename = new Date().getTime() + '.xlsx';
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                    } else if (res.data.code != 200) {
                        this.$message('暂无数据')
                    }
                    this.exporloading = false

                }).catch(err => {
                    this.exporloading = false

                })
            },
            handleDelete(row, index) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let url = `/admin/delPost`
                    axios.post(url, {
                        id: row.id
                    }, {
                        token: true
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search()
                        } else {

                        }
                    })

                }).catch(() => {

                });

            },
            getinfo() {
                let that = this
                axios
                    .get(`/admin/post/${this.dataId}/comment`, {
                        token: true
                    })
                    .then(response => {
                        that.listItem = response.data.data.list

                    })
                    .catch(error => {})
            },
            selectry() {
                this.zan = false
            },
            dzan() {
                if (!this.getruleForm.ry_value2) {

                    this.$message({
                        message: '请先选择人员哦',
                        type: 'warning'
                    });
                    return

                }
                axios.post('/admin/pc/support', {
                    post_id: this.dataId,
                    type: 0,
                    userId: this.getruleForm.ry_value2
                }, {
                    token: true
                }).then(res => {
                    if (res.data.code == 200 && res.data.errorCode == 999) {
                        this.$message({
                            message: '已经赞过了',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: '点赞成功',
                            type: 'success'
                        });

                        this.zan = true
                    }
                })

            },
            handle_top(row, val) {
                axios
                    .post("/admin/pc/post/edit_top", {
                        id: row.id,
                        is_top: val
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                            this.search()
                        } else {
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch(error => {})
            },
            jhbtn(row, val) {
                axios
                    .post("/admin/pc/post/edit_essence", {
                        id: row.id,
                        is_essence: val
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                            this.search()
                        } else {
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch(error => {})
            },
            ydbtn(row) {
                this.eid = row.id
                this.moveForm.move = ''
                this.dialog_move = true
            },
            beforeUpload() {
                if (!this.ruleForm.ry_value) {
                    this.$message({
                        message: '请先选择人员哦',
                        type: 'warning'
                    });
                    return false
                }
            },
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                that.moveheight = window.innerHeight - 280 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                    that.moveheight = window.innerHeight - 280 + 'px'

                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                // start_time: this.times ? this.times[0] : '',
                // end_time: this.times ? this.times[1] : '',
                axios.get(
                        `/admin/pc/postclass/${that.lb_value}/post/${that.currentPage}?limit=${this.pagesize}&userId=${this.user.id}&ht=1&topic_id=${this.titles}&start=${(this.times&&this.times.length>0)?this.times[0]:''}&end=${(this.times&&this.times.length>0)?this.times[1]:''}`, {
                            token: true
                        })
                    .then(response => {
                        that.loading = false

                        that.tableData = response.data.data.list
                        that.count = response.data.data.count

                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = '0'
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm.lb_value = ''
                that.ruleForm.lb_put = 1
                that.ruleForm.lb_dstime = ''
                that.ruleForm.textarea = ''
                this.ruleForm.keyword = ''
                that.ruleForm.kj_value = ''
                that.ruleForm.ht_value2 = ''
                that.ruleForm.lb_mapList = []
                that.ruleForm.ry_value = ''
                that.ruleForm.ht_value = ''
                that.mapListed = []
            },
            // 鼠标单击的事件
            onClick(e, editor) {},
            submit(formName) {
                let that = this
                var time;
                if (that.ruleForm.lb_put == '1') {
                    time = that.gettimes()
                } else if (that.ruleForm.lb_put == '2') {
                    time = that.ruleForm.lb_dstime
                } else {
                    time = that.ruleForm.lb_put
                }
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let arr1 = []
                        let obj = {}
                        that.mapListed.forEach(ele => {
                            obj = {
                                id: ele.id
                            }
                            arr1.push(obj)
                        })
                        if (that.mapListed.length < 1) return that.$message.error('请上传图文封面');
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/pc/updatePost"
                        } else {
                            urls = "/admin/pc/post/create"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                imglist: arr1,
                                text: this.ruleForm.textarea,
                                isopen: 1,
                                topic_id: '',
                                to_show: that.ruleForm.lb_put,
                                show_time: time,
                                post_class_id: this.ruleForm.lb_value,
                                userId: this.ruleForm.ry_value,
                                keyword: this.ruleForm.keyword,
                                is_fictitious: 2,
                                status: 1,
                                anonymous: 0
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            handleexam(index, row) {
                this.examdialogs = true
                this.topic_id = row.topic_id
                this.eid = row.id
                this.examdata = row
                this.examForm.name = row.title
                this.examForm.remark = row.examine_remark
                this.examForm.examradio = row.status
                this.examForm.content = row.content

            },
            //编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                this.ruleForm.lb_mapList = []
                this.mapListed = []
                this.mapListed = row.images
                this.ruleForm.lb_mapList = row.images
                that.dialogVisible = true
                that.eid = row.id
                that.ruleForm.ht_value = row.post_class_id
                // that.selecthttit()
                that.ruleForm.lb_value = row.post_class_id
                that.ruleForm.textarea = row.content
                that.ruleForm.kj_value = row.isopen
                this.ruleForm.lb_dstime = row.show_time
                this.ruleForm.lb_put = row.to_show
                if (row.is_fictitious == 2) {
                    that.ruleForm.ry_value = row.users.id
                } else {
                    that.ruleForm.ry_value = ''
                }
                // var ry_id = that.ry_options.find(function (x) {
                //     return x.id == row.user_id
                // }).id
                // if (ry_id) {
                //     that.ruleForm.ry_value = row.user_id
                // } else {
                //     that.ruleForm.ry_value = ''
                // }
                that.ruleForm.keyword = row.keyword
                that.ruleForm.ht_value2 = row.topic_id
            },

            plsubmit() {
                if (!this.getruleForm.ry_value2) {
                    this.$message({
                        message: '请先选择人员哦',
                        type: 'warning'
                    });
                    return
                }
                if (!this.getruleForm.pltext) {
                    this.$message({
                        message: '评论不能为空',
                        type: 'warning'
                    });
                    return
                }
                axios.post('/admin/pc/comment', {
                    post_id: this.dataId,
                    dataId: this.dataId,
                    fid: 0,
                    content: this.getruleForm.pltext,
                    userId: this.getruleForm.ry_value2,
                    is_fictitious: 2,
                    reply_id: '',
                    reply_type: '',
                    user_avatar: '',
                    to_user: '',
                    to_user_text: '',
                }, {
                    token: true
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '评论成功',
                            type: 'success'
                        });
                        this.detaildialogVisible = false
                    }
                })
            },
            detailbtn(row, index) {
                this.dataId = row.id
                this.zan = false
                this.detaildialogVisible = true
                this.getinfo()
                this.getruleForm.rytext = row.is_fictitious == 2 ? row.users.username : row.user.username
                this.getruleForm.pltext = ''
                this.getruleForm.ry_value2 = ''
                this.getruleForm.ht_value2 = row.ht
                this.getruleForm.images = row.images
                let obj = {}
                // row.images.forEach(ele => {
                //     obj = {
                //         url: ele.url
                //     }
                //     this.getruleForm.images.push(obj)
                // })
                this.getruleForm.textarea = row.content
                this.getruleForm.kj_value = row.isopen
                this.getruleForm.ry_value = ''
            },
            dsbtn(row) {
                this.eid = row.id
                this.user_id = row.user_id
                this.dsForm.count = 0
                this.dialog_dsjf = true
            },

            // 删除
            handleDelet(row, index) {
                let that = this
                this.$prompt(`要删除此评论,请输入删除理由`, '温馨提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal: true,
                    beforeClose(action, instance, done) {
                        if (action == 'confirm') {
                            if (instance.inputValue) {
                                that.del(done, instance.inputValue, row)
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '删除理由不得为空！'
                                });
                            }
                        } else {
                            done()
                        }
                    }
                }).then(({
                    value
                }) => {}).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消'
                    });
                });
            },
            del(d, v, r) {
                let url = `/admin/pc/delComment`
                axios.post(url, {
                    id: r.id,
                    role: 'admin',
                    destroy_remark: v,
                    user_id: r.user_id
                }, {
                    token: true
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        d()
                        this.getinfo()
                    } else {

                    }
                })
            },
            gettimes() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                let hour = nowDate.getHours(); //获取系统时，
                let min = nowDate.getMinutes(); //分
                let sec = nowDate.getSeconds(); //秒
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                hour = hour > 9 ? hour : '0' + hour
                min = min > 9 ? min : '0' + min
                sec = sec > 9 ? sec : '0' + sec
                return `${year}-${month}-${day} ${hour}:${min}`;
            },
            // 类别
            getlbxx() {
                let that = this
                that.lb_options = []
                axios
                    .get(`/admin/pc/postclass`, {
                        headers: {
                            'token': this.user.token
                        }
                    })
                    .then(response => {
                        var data = response.data.data.list
                        data.forEach(element => {
                            if (element.id != 7) {
                                that.lb_options.push(element)
                            }
                        });
                        this.lb_value = that.lb_options[0].id
                        this.ruleForm.lb_value = that.lb_options[0].id
                        that.begin()
                    })
                    .catch(error => {})
            },
            // 获取人员
            getper() {
                let that = this
                axios
                    .post(`/admin/doctorAssistantList`, {}, {
                        token: true
                    })
                    .then(response => {
                        that.ry_options = response.data.data
                    })
                    .catch(error => {})
            },
            // 获取话题类
            gethtlist() {
                let that = this
                axios
                    .get("/admin/pc/topicclass", {
                        'token': true
                    })
                    .then(response => {
                        that.ht_options = response.data.data.list

                    })
                    .catch(error => {})
            },
            // // 获取话题列表
            // selecthttit() {
            //     let that = this
            //     this.ruleForm.ht_value2 = ''
            //     axios
            //         .get(`/admin/pc/topicclass/${this.ruleForm.ht_value}/topic/1?userId=${this.user.id}&all=1`, {
            //             'token': true
            //         })
            //         .then(response => {
            //             that.ht_options2 = response.data.data.list

            //         })
            //         .catch(error => {})
            // },
            // 获取话题列表
            edit_selecthttit(topic_id) {
                let that = this
                that.topic_child_options = [];
                axios
                    .get(`/admin/pc/topicclass/${topic_id}/topic/1?userId=${this.user.id}&all=1`, {
                        'token': true
                    })
                    .then(response => {
                        that.topic_child_options = response.data.data.list

                    })
                    .catch(error => {})
            },
            goprev(item) {
                let that = this
                that.dialog_prev = true
                that.urls = item
            },
            // 
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            delclick(row) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/delComment", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getinfo()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 审核
            examsubmit() {
                if (this.examForm.examradio == 2 && this.examForm.remark == '') {
                    this.$message({
                        message: '请输入拒绝理由',
                        type: 'warning'
                    });
                    return
                }

                let params = {}
                let urls = ''

                urls = '/admin/pc/post/examine'
                params = {
                    id: this.eid,
                    status: this.examForm.examradio,
                    examine_remark: this.examForm.remark,
                    topic_id: this.topic_id
                }
                this.examloading = true
                axios
                    .post(urls, params, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == 200) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.examdialogs = false
                            this.search()
                        } else {
                            this.$message({
                                message: response.data.msg,
                                type: 'warning'
                            });
                        }
                        this.examloading = false
                    })
                    .catch(error => {})
            },
            async dssubmit() {
                if (this.dsForm.count < 1) return this.$message('打赏积分不得小于1')
                this.$confirm(`确认打赏${this.dsForm.count}积分吗, 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.subloading = true
                    let res = await this.ajax('rewardPoint', {
                        id: this.eid,
                        user_id: this.user_id,
                        point: this.dsForm.count,
                    })
                    this.subloading = false
                    if (res.code == 200) {
                        this.$message(res.msg)
                        this.dialog_dsjf = false
                    } else {
                        this.$message(res.msg)
                    }
                }).catch(() => {

                });
            },
            async movesubmit() {
                if (!this.moveForm.move) return this.$message('请选择要移动到的圈子')
                this.subloading = true
                let res = await this.ajax('/post/edit_topic', {
                    id: this.eid,
                    topic_id: this.moveForm.move
                })
                this.subloading = false
                if (res.code == 200) {
                    this.$message.success('移动成功！')
                    this.search()
                    this.dialog_move = false
                } else {
                    this.$message(res.msg)
                }
            }
        },

    };
</script>


<style scoped>
    .con_de {
        /* border: 1px solid red; */
        /* width: 200px; */
        width: 100%;
        max-height: 200px;
        overflow-y: scroll;
        line-height: 18px;
        position: relative;
        top: 7px;
        background-color: rgb(247, 245, 245);
        border-radius: 5px;
        padding: 5px;
    }

    .imgs {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
    }

    .lefts {
        max-height: 500px;
        overflow: auto;
    }

    .delt {
        color: red;
        font-size: 20px;
    }

    .blues {
        color: #409eff;
    }

    .concon {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 10px;
    }

    .zanbtn {
        width: 30px;
        display: flex;
        /* border: 1px solid red; */
        cursor: pointer;
    }

    .zanbtn img {
        width: 100%;
        display: block;
    }

    .singleimg {
        width: 50px;
    }

    .singleimg img {
        width: 100%;
        height: 100%;
        display: block;
    }

    .imgbox {
        display: flex;

        flex-wrap: wrap;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .tablimg {
        margin: 2px 5px;
    }
</style>